import React from 'react';

function SvgEchIconFieldInfo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={12} cy={12.5} r={11} stroke="#5F013D" strokeWidth={2} />
      <circle cx={12} cy={7.5} r={1} fill="#5F013D" />
      <rect x={11} y={10.5} width={2} height={9} fill="#5F013D" />
    </svg>
  );
}
export default SvgEchIconFieldInfo;
